import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface SendEmailXpoData {
  [key: string]: unknown;
}

export const sendEmailXpoAPI = (data: SendEmailXpoData) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.LOSS_AND_DAMAGE}/ExportToXpo`,
  });
};

export type SendEmailXpoResponse = unknown;

export const sendEmailXpo = async (data: SendEmailXpoData): Promise<SendEmailXpoResponse> => {
  const response: AxiosResponse<SendEmailXpoResponse> = await sendEmailXpoAPI(data);
  return response.data;
};
